<template>
	<div :class="wrap ? 'whitespace-normal break-all' : 'whitespace-nowrap'">
		{{ action }}
		<ConsoleLink :href="url" target="_blank">{{ url }}</ConsoleLink>
	</div>
</template>

<script>
import ConsoleLink from 'shared/components/ConsoleLink.vue'

export default {
	name: 'ConsoleStep',
	components: {ConsoleLink},
	props: {event: Object, wrap: Boolean},
	computed: {
		action() {
			return (
				{
					reload: 'Reloaded ',
					navigate: 'Navigated to ',
					start: 'Screen Recording Started', // deprecated after v1.2.18
					stop: 'Screen Recording Ended', // deprecated after v1.2.18
					close: 'Closed ',
					focusTab: 'Tab switched to ',
				}[this.event.action] || this.event.action
			)
		},
		url() {
			switch (this.event.action) {
				case 'navigate': {
					return this.event.newUrl
				}
				case 'reload':
				case 'close': {
					return this.event.url
				}
				case 'focusTab': {
					return this.event.newUrl
				}
			}
			return ''
		},
	},
}
</script>
